const HomeListings = [
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-26117817/original/9da40e3c-5846-4359-bb41-05c27b09a8f5.jpeg?im_w=720",
    "Jibhi, India",
    "1,481 kilometres away",
    "20 - 25 Nov",
    "6,846",
    ["4.9", "168"],
    "https://www.airbnb.co.in/rooms/26117817?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-20&check_out=2022-11-25&federated_search_id=153774e5-26be-4524-98cd-1755e821f39c&source_impression_id=p3_1667482613_skUgcUOlAvXcv8zD",
  ],
  [
    "https://a0.muscache.com/im/pictures/093ce60a-2ee0-4499-a77e-3d531110a132.jpg?im_w=720",
    "Naxos, Greece",
    "1 double bed",
    "1 - 6 Dec",
    "5,596",
    ["4.77", "44"],
    "https://www.airbnb.co.in/rooms/26810702?adults=1&category_tag=Tag%3A789&children=0&infants=0&pets=0&check_in=2022-12-01&check_out=2022-12-06&source_impression_id=p3_1667482976_7BCwBMx4NQlrKPwD",
  ],
  [
    "https://a0.muscache.com/im/pictures/d8d629d7-9307-4b24-a8ae-b01d95e36124.jpg?im_w=720",
    "Nashik, India",
    "1,547 kilometres away",
    "7 - 12 Nov",
    "5,706",
    ["4.86", "91"],
    "https://www.airbnb.co.in/rooms/21702657?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-07&check_out=2022-11-12&federated_search_id=153774e5-26be-4524-98cd-1755e821f39c&source_impression_id=p3_1667482642_ATse%2BVS52roEHEF8",
  ],
  [
    "https://a0.muscache.com/im/pictures/prohost-api/Hosting-17473199/original/c14061e5-eae2-4525-bf4c-b3dd21262faf.jpeg?im_w=720",
    "Montegufoni, Italy",
    "3 beds",
    "6 - 12 Nov",
    "10,523",
    ["4.5", "8"],
    "https://www.airbnb.co.in/rooms/17473199?adults=1&category_tag=Tag%3A8524&children=0&infants=0&pets=0&check_in=2022-11-06&check_out=2022-11-12&source_impression_id=p3_1667483221_whoH1r3452u0bwOX",
  ],
  [
    "https://a0.muscache.com/im/pictures/335e9565-51c3-4201-a351-4e567740be3c.jpg?im_w=720",
    "Manali, India",
    "1,533 kilometres away",
    "10 - 15 Nov",
    "12,359",
    ["5.0", "17"],
    "https://www.airbnb.co.in/rooms/20693855?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-10&check_out=2022-11-15&federated_search_id=153774e5-26be-4524-98cd-1755e821f39c&source_impression_id=p3_1667482661_JEUE1s75xyst4XSc",
  ],
  [
    "https://a0.muscache.com/im/pictures/44218a58-417a-4d70-95cd-3939f95a57b1.jpg?im_w=720",
    "Colares, Portugal",
    "6 beds",
    "6 - 11 Dec",
    "24,935",
    ["4.96", "107"],
    "https://www.airbnb.co.in/rooms/3296978?adults=1&category_tag=Tag%3A8526&children=0&infants=0&pets=0&check_in=2022-12-06&check_out=2022-12-11&source_impression_id=p3_1667483382_STSahXoJWxJ%2F9%2F9d",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-53292428/original/b34236f9-7547-4573-8468-9dc701c8eec1.jpeg?im_w=720",
    "Jaipur, India",
    "1,371 kilometres away",
    "7 - 12 Nov",
    "9,070",
    ["4.82", "11"],
    "https://www.airbnb.co.in/rooms/53292428?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-07&check_out=2022-11-12&federated_search_id=153774e5-26be-4524-98cd-1755e821f39c&source_impression_id=p3_1667482684_UT4mEGUQAw2D2VmF",
  ],
  [
    "https://a0.muscache.com/im/pictures/prohost-api/Hosting-577560955900006368/original/ccb694a7-be72-4e55-89a1-6ce22dc5da22.png?im_w=720",
    "Jersey City",
    "2 kilometres from New York",
    "6 - 12 Nov",
    "25,899",
    ["4.69", "180"],
    "https://www.airbnb.co.in/rooms/577560955900006368?adults=1&category_tag=Tag%3A789&children=0&infants=0&pets=0&search_mode=flex_destinations_search&check_in=2022-11-06&check_out=2022-11-12&source_impression_id=p3_1667525592_fmdCbdUXobQPPJAm",
  ],
  [
    "https://a0.muscache.com/im/pictures/0090cc3f-5431-4a82-8fe7-174a31fe093a.jpg?im_w=720",
    "Naggar, India",
    "1,531 kilometres away",
    "9 - 16 Nov",
    "15,406",
    ["5.0", "43"],
    "https://www.airbnb.co.in/rooms/23897494?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-09&check_out=2022-11-16&federated_search_id=153774e5-26be-4524-98cd-1755e821f39c&source_impression_id=p3_1667482700_ZqXIxiMjAA7Z8AE6",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-749907745435322296/original/277aead5-c43e-46c5-8617-83cd276d11bf.jpeg?im_w=720",
    "Ciudad de México",
    "2 beds",
    "4 - 9 Dec",
    "8,910",
    ["New", "0"],
    "https://www.airbnb.co.in/rooms/749907745435322296?adults=1&children=0&infants=0&pets=0&check_in=2022-12-04&check_out=2022-12-09&source_impression_id=p3_1667525858_Eug4Q8fao8KldcSj",
  ],
  [
    "https://a0.muscache.com/im/pictures/0c4f6bfd-07ee-455b-8855-f9e7c23faa2f.jpg?im_w=720",
    "Darjeeling, India",
    "1 king bed",
    "4 - 9 Nov",
    "1,255",
    ["4.79", "28"],
    "https://www.airbnb.co.in/rooms/48762845?adults=1&children=0&infants=0&pets=0&check_in=2022-11-04&check_out=2022-11-09&source_impression_id=p3_1667525978_fxu3QwpDrqHNHTLL",
  ],
  [
    "https://a0.muscache.com/im/pictures/fe84676f-e446-45b2-9d35-bcaf5dbc7469.jpg?im_w=720",
    "Bondi Beach, Sydney",
    "7 kilometres from Sydney",
    "12 - 17 Dec",
    "29,464",
    ["4.83", "217"],
    "https://www.airbnb.co.in/rooms/31596128?adults=1&category_tag=Tag%3A8536&children=0&infants=0&pets=0&search_mode=flex_destinations_search&check_in=2022-12-12&check_out=2022-12-17&source_impression_id=p3_1667526212_bbW7Ge8md%2FSVMoP%2B",
  ],
  //farm listings from index 12
  [
    "https://a0.muscache.com/im/pictures/8dfd1593-6fef-4c9c-b3a2-7ca0e489db9b.jpg?im_w=720",
    "Siolim, India",
    "1,716 kilometres away",
    "27 Nov - 2 Dec",
    "16,729",
    ["4.79", "56"],
    "https://www.airbnb.co.in/rooms/48781165?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-27&check_out=2022-12-02&federated_search_id=ec19f94d-e15d-48fe-b9f5-d3b3ef8c92b2&source_impression_id=p3_1667630866_2XO%2BeX1%2FRqLEJsCA",
  ],
  [
    "https://a0.muscache.com/im/pictures/35796568-7f51-4455-90fd-adbb69876346.jpg?im_w=720",
    "Sanguri Gaon, India",
    "1,157 kilometres away",
    "8 - 13 Nov",
    "9,116",
    ["4.94", "81"],
    "https://www.airbnb.co.in/rooms/40665944?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-08&check_out=2022-11-13&federated_search_id=ec19f94d-e15d-48fe-b9f5-d3b3ef8c92b2&source_impression_id=p3_1667631561_42fSsjGJGufdHsg2",
  ],
  [
    "https://a0.muscache.com/im/pictures/b6c23ebc-81df-4920-a325-341c71a79950.jpg?im_w=720",
    "Varca, India",
    "1,722 kilometres away",
    "27 Nov - 3 Dec",
    "9,200",
    ["4.85", "97"],
    "https://www.airbnb.co.in/rooms/45796358?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-27&check_out=2022-12-03&federated_search_id=ec19f94d-e15d-48fe-b9f5-d3b3ef8c92b2&source_impression_id=p3_1667640999_x7dibxZEAn3K%2BHbb",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-52844386/original/30562e85-22ae-4e6f-aa80-8bf400ef301a.jpeg?im_w=720",
    "Pune, India",
    "1,586 kilometres away",
    "8 - 13 Nov",
    "3,217",
    ["4.93", "30"],
    "https://www.airbnb.co.in/rooms/52844386?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-08&check_out=2022-11-13&federated_search_id=ec19f94d-e15d-48fe-b9f5-d3b3ef8c92b2&source_impression_id=p3_1667641451_CPPSpXLC%2FXT27tJk",
  ],
  [
    "https://a0.muscache.com/im/pictures/4b971242-a308-47ba-a4ca-b58743d4651a.jpg?im_w=720",
    "North Goa, India",
    "1,718 kilometres away",
    "20 - 25 Nov",
    "21,039",
    ["4.86", "66"],
    "https://www.airbnb.co.in/rooms/24545501?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-20&check_out=2022-11-25&federated_search_id=0d10db16-99d6-4d84-9b42-e19cd80e8a69&source_impression_id=p3_1667641669_1XWJijQnmAFSXWxH",
  ],
  [
    "https://a0.muscache.com/im/pictures/87caa52b-c9b9-4b98-8d67-2ab3b066c972.jpg?im_w=720",
    "Mu Si, Thailand",
    "1,635 kilometres away",
    "8 - 13 Jan",
    "10,219",
    ["4.9", "269"],
    "https://www.airbnb.co.in/rooms/28941922?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2023-01-08&check_out=2023-01-13&federated_search_id=0d10db16-99d6-4d84-9b42-e19cd80e8a69&source_impression_id=p3_1667641890_KpV5ErAKXsRUMNAo",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-669873114915769259/original/5ec53027-79f2-4e47-a2a2-5c55eb69045d.jpeg?im_w=720",
    "Nerul, India",
    "1,721 kilometres away",
    "9 - 14 Nov",
    "22,500",
    ["5.0", "5"],
    "https://www.airbnb.co.in/rooms/669873114915769259?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-09&check_out=2022-11-14&federated_search_id=0d10db16-99d6-4d84-9b42-e19cd80e8a69&source_impression_id=p3_1667642139_M7XAJeYBNhOtxvkJ",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-637436694291207290/original/e3024404-e451-41a1-9206-2269a9b3de8a.jpeg?im_w=720",
    "Panchgani, India",
    "1,608 kilometres away",
    "13 - 18 Nov",
    "34,235",
    ["4.9", "1"],
    "https://www.airbnb.co.in/rooms/637436694291207290?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-13&check_out=2022-11-18&federated_search_id=0d10db16-99d6-4d84-9b42-e19cd80e8a69&source_impression_id=p3_1667642378_%2FCQEl4TUuqOZxB0V",
  ],
  [
    "https://a0.muscache.com/im/pictures/967e43eb-46ee-4d78-9fed-b7c00585e5fa.jpg?im_w=720",
    "Kufri, India",
    "1,452 kilometres away",
    "5 - 11 Nov",
    "6,847",
    ["4.83", "18"],
    "https://www.airbnb.co.in/rooms/48741794?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-05&check_out=2022-11-11&federated_search_id=0d10db16-99d6-4d84-9b42-e19cd80e8a69&source_impression_id=p3_1667642604_ynbX9faZdMxzXIeh",
  ],
  [
    "https://a0.muscache.com/im/pictures/bd110b6a-fe48-499c-9b9e-c05006127be6.jpg?im_w=720",
    "Ubud, Indonesia",
    "4,531 kilometres away",
    "15 - 20 Jan",
    "21,163",
    ["4.88", "418"],
    "https://www.airbnb.co.in/rooms/plus/785976?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2023-01-15&check_out=2023-01-20&federated_search_id=100be43d-38be-41c7-b3d1-2effb003b4d3&source_impression_id=p3_1667642834_5g%2FlyK0b9vbIiK1x",
  ],
  [
    "https://a0.muscache.com/im/pictures/6cf89556-4867-4deb-919b-2b5146971771.jpg?im_w=720",
    "Villalba, Puerto Rico",
    "14,730 kilometres away",
    "20 - 25 Nov",
    "36,687",
    ["4.89", "571"],
    "https://www.airbnb.co.in/rooms/plus/31295317?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-20&check_out=2022-11-25&federated_search_id=100be43d-38be-41c7-b3d1-2effb003b4d3&source_impression_id=p3_1667643115_TwdrrGJbFcpKu2sy",
  ],
  [
    "https://a0.muscache.com/im/pictures/885f55d3-8ea0-4a2f-ba86-1e9e435f2050.jpg?im_w=720",
    "Waco, Texas, US",
    "13,957 kilometres away",
    "13 - 18 Nov",
    "7,700",
    ["4.94", "502"],
    "https://www.airbnb.co.in/rooms/plus/31444396?adults=1&category_tag=Tag%3A8175&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-13&check_out=2022-11-18&federated_search_id=100be43d-38be-41c7-b3d1-2effb003b4d3&source_impression_id=p3_1667643368_8WgYtS9toPcgRfOY",
  ],
  //OMG Category starts
  [
    "https://a0.muscache.com/im/pictures/e28d45ab-175b-45e4-9e22-9f2fc12b30df.jpg?im_w=720",
    "Mayne Island, Canada",
    "11,477 kilometres away",
    "29 Oct - 3 Nov",
    "13,927",
    ["4.98", "656"],
    "https://www.airbnb.co.in/rooms/plus/1720832?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2023-10-29&check_out=2023-11-03&federated_search_id=9de20925-d991-4bf7-9537-07f64a4a3b79&source_impression_id=p3_1667643691_YdMgiWhbu5lBGSEb",
  ],
  [
    "https://a0.muscache.com/im/pictures/b7c9264d-73c9-45c3-882e-6e9577d63d68.jpg?im_w=720",
    "Drimnin, UK",
    "8,186 kilometres away",
    "17 - 22 Nov",
    "17,489",
    ["4.95", "322"],
    "https://www.airbnb.co.in/rooms/plus/19997279?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-17&check_out=2022-11-22&federated_search_id=9de20925-d991-4bf7-9537-07f64a4a3b79&source_impression_id=p3_1667644147_uK%2BNtJlxLqIa%2Btdf",
  ],
  [
    "https://a0.muscache.com/im/pictures/d89a974e-73db-4ba6-b2f4-8e1876534731.jpg?im_w=720",
    "Paraty, Brazil",
    "15,240 kilometres away",
    "7 - 12 Dec",
    "16,561",
    ["4.89", "235"],
    "https://www.airbnb.co.in/rooms/plus/6823091?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-12-07&check_out=2022-12-12&federated_search_id=83012862-4522-48b3-9dd2-5cd3d0cc430f&source_impression_id=p3_1667644419_4%2B9F7Ovs2tp4bni8",
  ],
  [
    "https://a0.muscache.com/im/pictures/0c7865ec-d2f0-4fd1-8e29-3613d0a86724.jpg?im_w=720",
    "Bingin Beach, Indonesia",
    "4,546 kilometres away",
    "19 - 25 Nov",
    "27,678",
    ["4.94", "49"],
    "https://www.airbnb.co.in/rooms/plus/24151385?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-19&check_out=2022-11-25&federated_search_id=83012862-4522-48b3-9dd2-5cd3d0cc430f&source_impression_id=p3_1667644620_FFJD2F9e8axH2ygF",
  ],
  [
    "https://a0.muscache.com/im/pictures/f6734841-4bd2-4919-b75a-5333907a0389.jpg?im_w=720",
    "Mill Valley, California, US",
    "12,558 kilometres away",
    "11 - 17 Dec",
    "14,148",
    ["4.92", "1,410"],
    "https://www.airbnb.co.in/rooms/plus/3712191?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-12-11&check_out=2022-12-17&federated_search_id=83012862-4522-48b3-9dd2-5cd3d0cc430f&source_impression_id=p3_1667644861_e3zJZGvMqWDRJ4yw",
  ],
  [
    "https://a0.muscache.com/im/pictures/609ea98f-598c-41e1-bef9-5a604a9da7dd.jpg?im_w=720",
    "Gifford, UK",
    "8,018 kilometres away",
    "27 Nov - 2 Dec",
    "14,352",
    ["4.99", "92"],
    "https://www.airbnb.co.in/rooms/plus/16599025?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-27&check_out=2022-12-02&federated_search_id=83012862-4522-48b3-9dd2-5cd3d0cc430f&source_impression_id=p3_1667645126_SIYRMW%2BeXrmJBpNw",
  ],
  [
    "https://a0.muscache.com/im/pictures/280abc07-1737-4d2d-aa09-63e58dc5d13a.jpg?im_w=720",
    "Phoenix, Arizona, US",
    "13,409 kilometres away",
    "20 - 25 Nov",
    "13,845",
    ["4.9", "220"],
    "https://www.airbnb.co.in/rooms/plus/23583843?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-20&check_out=2022-11-25&federated_search_id=83012862-4522-48b3-9dd2-5cd3d0cc430f&source_impression_id=p3_1667645358_v02WLC%2FrZxhp43v1",
  ],
  [
    "https://a0.muscache.com/im/pictures/e25a9b25-fa98-4160-bfd1-039287bf38b6.jpg?im_w=720",
    "Abiansemal, Indonesia",
    "4,532 kilometres away",
    "10 - 17 Sep",
    "29,672",
    ["4.87", "156"],
    "https://www.airbnb.co.in/rooms/34113796?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2023-09-10&check_out=2023-09-17&federated_search_id=f48573bc-1cdd-41e0-970b-7f79ecfff7cc&source_impression_id=p3_1667645558_idYG51WyYO5LM5QC",
  ],
  [
    "https://a0.muscache.com/im/pictures/337660c5-939a-439b-976f-19219dbc80c7.jpg?im_w=720",
    "Volimes, Greece",
    "6,579 kilometres away",
    "2 - 8 Dec",
    "13,894",
    ["4.89", "47"],
    "https://www.airbnb.co.in/rooms/34749360?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-12-02&check_out=2022-12-08&federated_search_id=5fe9b7d3-ec1f-448b-856d-d0723a97cb18&source_impression_id=p3_1667645753_ah1fVvYGJSXhc1IB",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-51188616/original/0ff70bd6-791a-4035-b6de-0ed9135cdda1.jpeg?im_w=720",
    "La Balme-de-Thuy, France",
    "7,636 kilometres away",
    "5 - 10 Nov",
    "14,610",
    ["4.88", "24"],
    "https://www.airbnb.co.in/rooms/51188616?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-05&check_out=2022-11-10&federated_search_id=5fe9b7d3-ec1f-448b-856d-d0723a97cb18&source_impression_id=p3_1667645928_srD2Kas2t0xTzDlD",
  ],
  [
    "https://a0.muscache.com/im/pictures/9da86cdc-07fa-4d4b-930b-b31752279e19.jpg?im_w=720",
    "Usma, Latvia",
    "6,491 kilometres away",
    "5 - 10 Nov",
    "3,983",
    ["4.86", "28"],
    "https://www.airbnb.co.in/rooms/50041663?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-05&check_out=2022-11-10&federated_search_id=5fe9b7d3-ec1f-448b-856d-d0723a97cb18&source_impression_id=p3_1667646171_waYepGhnx6ddjVbf",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-52232950/original/c1a329c4-f3f6-4b58-921c-bea809877fd4.jpeg?im_w=720",
    "Nideggen, Germany",
    "7,533 kilometres away",
    "27 Nov - 2 Dec",
    "7,467",
    ["4.92", "39"],
    "https://www.airbnb.co.in/rooms/52232950?adults=1&category_tag=Tag%3A8225&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-27&check_out=2022-12-02&federated_search_id=5fe9b7d3-ec1f-448b-856d-d0723a97cb18&source_impression_id=p3_1667646525_5ytUBuJVYixhLxLZ",
  ],
  //beaches category start here
  [
    "https://a0.muscache.com/im/pictures/f61bc4ba-1a19-49c2-857a-186e1d9d92d2.jpg?im_w=720",
    "Ko Samui, Thailand",
    "Laem Yai",
    "24 - 29 Jan",
    "4,764",
    ["4.91", "56"],
    "https://www.airbnb.co.in/rooms/28298543?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2023-01-24&check_out=2023-01-29&federated_search_id=e789f759-a726-4d23-a346-53541cd1b210&source_impression_id=p3_1667649982_DKyBFALByaZrZzpD",
  ],
  [
    "https://a0.muscache.com/im/pictures/5bf5fbbe-ab49-42db-bf43-6634315c3167.jpg?im_w=720",
    "koh phangan, Thailand",
    "Haad Baan Tai Beach",
    "28 May - 2 Jun",
    "6,822",
    ["4.99", "155"],
    "https://www.airbnb.co.in/rooms/8522934?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2023-05-28&check_out=2023-06-02&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667650216_RPvf1CZc0wBivkBR",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-48116280/original/3d624553-d3cc-4ba8-9963-8a46a520dcd9.jpeg?im_w=720",
    "Ko Samui District, Thailand",
    "1,915 kilometres away",
    "5 - 10 Nov",
    "7,687",
    ["4.89", "9"],
    "https://www.airbnb.co.in/rooms/48116280?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-05&check_out=2022-11-10&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667650543_S8nac%2BC9PTv3ofP0",
  ],
  [
    "https://a0.muscache.com/im/pictures/8633ee38-0d8a-4df2-bcf5-79ed2e858453.jpg?im_w=720",
    "Choeng Mon, Thailand",
    "Choeng Mon Beach",
    "19 - 24 Nov",
    "18,122",
    ["4.97", "64"],
    "https://www.airbnb.co.in/rooms/40869038?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-19&check_out=2022-11-24&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667652249_vFJSWrXYhnOvqO5z",
  ],
  [
    "https://a0.muscache.com/im/pictures/86eedea6-38c3-4fc4-8138-d21e12e03c55.jpg?im_w=720",
    "Tambon Bo Put, Thailand",
    "Choeng Mon Beach",
    "8 - 13 Nov",
    "33,850",
    ["4.98", "56"],
    "https://www.airbnb.co.in/rooms/20195543?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-08&check_out=2022-11-13&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667652910_Urd4aRzjZL5e6Xxe",
  ],
  [
    "https://a0.muscache.com/im/pictures/9b31f2bc-edde-4709-847c-50b88d0c07f4.jpg?im_w=720",
    "Tambon Bo Put, Thailand",
    "Choeng Mon Beach",
    "5 - 10 Nov",
    "72,901",
    ["5.0", "4"],
    "https://www.airbnb.co.in/rooms/43177563?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-05&check_out=2022-11-10&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667653143_4YvAe1M3qA%2Bl2XC3",
  ],
  [
    "https://a0.muscache.com/im/pictures/40dcd2b6-7b4f-4034-b9ea-5784236e1e61.jpg?im_w=720",
    "Koh samui, Thailand",
    "Bo Phut",
    "28 Nov - 3 Dec",
    "21,468",
    ["5.0", "6"],
    "https://www.airbnb.co.in/rooms/22380395?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-28&check_out=2022-12-03&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667653332_LQw9rff6YU%2FMlT%2BA",
  ],
  [
    "https://a0.muscache.com/im/pictures/2e74f7bd-f286-4f00-af7b-316518471a60.jpg?im_w=720",
    "Ko Tao, Thailand",
    "Sai Ri Beach",
    "17 - 22 Jan",
    "12,619",
    ["4.96", "26"],
    "https://www.airbnb.co.in/rooms/4106176?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2023-01-17&check_out=2023-01-22&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667653553_TpJuWpqPILRwlLai",
  ],
  [
    "https://a0.muscache.com/im/pictures/9fbd4f0f-f03c-431e-a83c-2a3c6fb7f505.jpg?im_w=720",
    "Bo Put Thailand",
    "Bo Phut",
    "5 - 10 Nov",
    "33,861",
    ["5.0", "6"],
    "https://www.airbnb.co.in/rooms/24658156?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-05&check_out=2022-11-10&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667653802_Aoas0jGfDoj61dOj",
  ],
  [
    "https://a0.muscache.com/im/pictures/93b756d6-9467-44b8-8016-d6ecbbfe8bf9.jpg?im_w=720",
    "Ko Pha Ngan, Thailand",
    "Haad Yao",
    "5 - 12 Dec",
    "12,648",
    ["4.92", "84"],
    "https://www.airbnb.co.in/rooms/38785424?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-12-05&check_out=2022-12-12&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667654004_Ngc%2BRRkrhqvXeRmu",
  ],
  [
    "https://a0.muscache.com/im/pictures/89a254d4-9553-4c2a-8d66-eab6b7a78638.jpg?im_w=720",
    "TH, Thailand",
    "Choeng Mon Beach",
    "17 - 22 Nov",
    "15,153",
    ["4.89", "73"],
    "https://www.airbnb.co.in/rooms/33184118?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-17&check_out=2022-11-22&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667654663_SrvqXBlymtC%2F7XFp",
  ],
  [
    "https://a0.muscache.com/im/pictures/24d61295-3139-4d27-b347-c9484277dff8.jpg?im_w=720",
    "Koh Samui, Thailand",
    "Hat Bang Po",
    "18 - 23 Nov",
    "9,172",
    ["4.91", "95"],
    "https://www.airbnb.co.in/rooms/13033788?adults=1&category_tag=Tag%3A7769&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-18&check_out=2022-11-23&federated_search_id=a1a942b7-3ee0-4219-8eb1-e3c699b334d9&source_impression_id=p3_1667654933_Ln9UQeXa2uq2ezEQ",
  ],
  //lakefront category starts here
  [
    "https://a0.muscache.com/im/pictures/f7be4b66-d6ad-4e47-95ce-7312403d155f.jpg?im_w=720",
    "Savonlinna, Finland",
    "6,221 kilometres away",
    "8 - 14 Nov",
    "9,425",
    ["4.99", "87"],
    "https://www.airbnb.co.in/rooms/35599157?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-08&check_out=2022-11-14&federated_search_id=4904f7bc-5abb-4f9a-a2a8-16ad7fafc948&source_impression_id=p3_1667655149_okezK7e8%2B5gdmIk5",
  ],
  [
    "https://a0.muscache.com/im/pictures/96cbd45e-a50d-44b8-973f-a78b2f39af85.jpg?im_w=720",
    "Savonlinna, Finland",
    "6,199 kilometres away",
    "5 - 10 Nov",
    "10,258",
    ["4.89", "85"],
    "https://www.airbnb.co.in/rooms/24819405?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-05&check_out=2022-11-10&federated_search_id=4904f7bc-5abb-4f9a-a2a8-16ad7fafc948&source_impression_id=p3_1667655348_tDrfpR8VpFhvxyU%2F",
  ],
  [
    "https://a0.muscache.com/im/pictures/68bd1e80-73f9-4b8a-baba-4d2d90200d87.jpg?im_w=720",
    "Serdivan, Turkey",
    "5,746 kilometres away",
    "21 - 26 Nov",
    "11,427",
    ["4.9", "100"],
    "https://www.airbnb.co.in/rooms/43975743?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-21&check_out=2022-11-26&federated_search_id=4904f7bc-5abb-4f9a-a2a8-16ad7fafc948&source_impression_id=p3_1667655527_lMQc79wTuTe5gSnE",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-54069179/original/e58a4269-7cfe-4256-9aca-0ca0522e0c0d.jpeg?im_w=720",
    "Sapanca, Turkey",
    "5,746 kilometres away",
    "27 Nov - 4 Dec",
    "9,056",
    ["5.0", "4"],
    "https://www.airbnb.co.in/rooms/54069179?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-27&check_out=2022-12-04&federated_search_id=4904f7bc-5abb-4f9a-a2a8-16ad7fafc948&source_impression_id=p3_1667655702_Azs9GnNrUKmrcSnn",
  ],
  [
    "https://a0.muscache.com/im/pictures/d3d478b2-0bd4-4088-b584-b29425aa7628.jpg?im_w=720",
    "Sapanca, Turkey",
    "5,745 kilometres away",
    "21 - 26 Nov",
    "2,073",
    ["4.82", "77"],
    "https://www.airbnb.co.in/rooms/26775705?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-21&check_out=2022-11-26&federated_search_id=4904f7bc-5abb-4f9a-a2a8-16ad7fafc948&source_impression_id=p3_1667655940_2MRZEDWvT%2BjDL5qV",
  ],
  [
    "https://a0.muscache.com/im/pictures/ee363279-746d-4a68-b6eb-fb8298f69748.jpg?im_w=720",
    "Sapanca, Turkey",
    "5,745 kilometres away",
    "20 - 25 Nov",
    "2,022",
    ["4.87", "62"],
    "https://www.airbnb.co.in/rooms/26775441?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-20&check_out=2022-11-25&federated_search_id=4904f7bc-5abb-4f9a-a2a8-16ad7fafc948&source_impression_id=p3_1667656147_XLBV1fyj1wpM28CE",
  ],
  [
    "https://a0.muscache.com/im/pictures/e123592c-192c-4597-bfd4-272044c906fa.jpg?im_w=720",
    "Dubai, UAE",
    "3,379 kilometres away",
    "18 - 23 Dec",
    "33,385",
    ["4.89", "91"],
    "https://www.airbnb.co.in/rooms/23056662?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-12-18&check_out=2022-12-23&federated_search_id=4904f7bc-5abb-4f9a-a2a8-16ad7fafc948&source_impression_id=p3_1667656349_otT2cjPzvyK1wAFo",
  ],
  [
    "https://a0.muscache.com/im/pictures/3ad963f8-5afb-4461-95da-bf7d9d742699.jpg?im_w=720",
    "Srinagar, India",
    "1,839 kilometres away",
    "9 - 14 Nov",
    "2,282",
    ["5.0", "11"],
    "https://www.airbnb.co.in/rooms/31502216?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-09&check_out=2022-11-14&federated_search_id=094275dd-273f-4f82-946b-271cf4257b85&source_impression_id=p3_1667656617_9ry9jC2zz7W9F1Qp",
  ],
  [
    "https://a0.muscache.com/im/pictures/5c81a199-9f6a-4a2f-970b-52bb15540ce4.jpg?im_w=720",
    "Nainital, India",
    "1,168 kilometres away",
    "15 - 20 Nov",
    "5,032",
    ["4.79", "47"],
    "https://www.airbnb.co.in/rooms/52541993?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-15&check_out=2022-11-20&federated_search_id=26eca2cd-7b4b-41d7-9c6a-065deeb83181&source_impression_id=p3_1667656839_l1FKicHRoD3u4U9v",
  ],
  [
    "https://a0.muscache.com/im/pictures/b0773b47-e17d-46cf-a979-5ab74d579418.jpg?im_w=720",
    "Batumi, Georgia",
    "4,814 kilometres away",
    "1 - 6 Oct",
    "4,300",
    ["4.81", "49"],
    "https://www.airbnb.co.in/rooms/10336738?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2023-10-01&check_out=2023-10-06&federated_search_id=2ba428af-6a5c-494a-ab55-4146b007b029&source_impression_id=p3_1667657316_k34x7aEnG2Qw3ZbD",
  ],
  [
    "https://a0.muscache.com/im/pictures/miso/Hosting-46441244/original/b6e3d754-7115-4c24-ae2b-b3abd705fc7d.jpeg?im_w=720",
    "Udaipur, India",
    "1,513 kilometres away",
    "6 - 11 Nov",
    "1,140",
    ["4.88", "8"],
    "https://www.airbnb.co.in/rooms/48126414?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-06&check_out=2022-11-11&federated_search_id=2ba428af-6a5c-494a-ab55-4146b007b029&source_impression_id=p3_1667657474_ZpyQx0x3sdTpO9AJ",
  ],
  [
    "https://a0.muscache.com/im/pictures/bc95da4d-13a9-4d30-bbaa-923e9bc93490.jpg?im_w=720",
    "Lonavla, India",
    "1,609 kilometres away",
    "13 - 18 Nov",
    "7,998",
    ["4.83", "23"],
    "https://www.airbnb.co.in/rooms/52588682?adults=1&category_tag=Tag%3A8522&children=0&infants=0&search_mode=flex_destinations_search&check_in=2022-11-13&check_out=2022-11-18&federated_search_id=2ba428af-6a5c-494a-ab55-4146b007b029&source_impression_id=p3_1667657647_l%2FXtHltu4aIrj%2FVj",
  ],
];

export default HomeListings;
